import Component from '../inherited/Component';

export default class SetHeight extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
  }

  mount() {
    this._setElementHeight();

    window.addEventListener('resize', () => {
      this._setElementHeight();
    });

    this._ctx.on('radiant--set-height', () => {
      setTimeout(() => {
        this._setElementHeight();
      }, 100);
    });
  }

  _setElementHeight() {
    let targetElements = document.querySelectorAll(this._options.target);
    let maxHeight = 0;

    targetElements.forEach((el) => {
      el.style.height = 'auto';
    });

    targetElements.forEach((el) => {
      let elHeight = el.offsetHeight;

      if (elHeight > maxHeight) {
        maxHeight = elHeight;
      }
    });

    targetElements.forEach((el) => {
      el.style.height = maxHeight + 'px';
    });
  }
}
